const isBlank = s => !(s || '').toString().trim();

const isEmptyParam = p => {
    if (!isBlank(p.partner_macro)) return false;
    if (p.is_custom) {
        return isBlank(p.singular_key) && isBlank(p.field_name) && isBlank(p.description);
    }
    return true;
};

export const getEmptyClearableIndices = (filteredRows, ctx) => {
    const { mandatoryKeys, templatesUseMacroKey, keyHasOtherProvider } = ctx;
    const safe = [];
    const blockedByTemplates = [];
    filteredRows.forEach(({ p, i }) => {
        if (mandatoryKeys.has(p.singular_key)) return;
        if (!isEmptyParam(p)) return;
        const key = (p.singular_key || '').trim();
        if (key && templatesUseMacroKey(key) && !keyHasOtherProvider(key, i)) {
            blockedByTemplates.push({ index: i, key });
            return;
        }
        safe.push(i);
    });
    return { safe, blockedByTemplates };
};
